(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const koQuill = require('../components/ko.quill');
    const koModal = require('../components/ko.modal');
    const bootstrapToggle = require('../bindings/ko.bootstrapToggle');

    class EditRoleplayViewModel {
        constructor(data) {
            this.id = data.id;
            this.title = ko.observable(data.title || '');
            this.description = ko.observable(data.description || '{}');
            this.author = ko.observable(data.author || '');
            this.isPrivate = ko.observable(data.isPrivate || false);
            this.ignoreTurns = ko.observable(data.ignoreTurns || false);
            this.versions = ko.observableArray(data.descriptionVersions || []);
            this.historyOpen = ko.observable(false);
            this.setVersion = function(item) {
                this.description({
                    replace: true,
                    value: item.value
                });
            }.bind(this);
        }

        load() {
        }

        save() {
            if (this.id) {
                $.ajax('/api/roleplay/' + this.id, {
                    method: 'put',
                    data: {
                        id: this.id,
                        title: this.title(),
                        description: this.description(),
                        private: this.isPrivate(),
                        ignore: this.ignoreTurns()
                    },
                    success: data => {
                        if (data.success) {
                            window.location.href = '/roleplay/' + this.id;
                        }
                    }
                });
            } else {
                $.ajax('/api/roleplay', {
                    method: 'post',
                    data: {
                        title: this.title(),
                        description: this.description(),
                        private: this.isPrivate(),
                        ignore: this.ignoreTurns()
                    },
                    success: data => {
                        if (data.success) {
                            window.location.href = '/roleplay/' + data.id;
                        }
                    }
                });
            }
        }
    }

    module.exports = EditRoleplayViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/editRoleplayViewModel.js